<app-dropdown
  [closeMethod]="closeMethod"
  [title]="'Showing ' + notificationCount() + ' notifications'"
>
  @if (notificationsLoading()) {
    <app-loading></app-loading>
  }
  @if (!notificationsLoading()) {
    <div>
      <div class="notifications">
        <div class="body">
          <ng-container>
            @if (notificationCount() > 0) {
              @for (
                notification of notifications();
                track notification.fingerprint_id
              ) {
                <app-notification
                  [notification]="notification"
                ></app-notification>
              }
            } @else {
              <div class="no-notifications">
                {{
                  "dropdown-notifications.message.no-notifications" | translate
                }}
              </div>
            }
          </ng-container>
        </div>
      </div>
    </div>
  }
  <div class="view-all" dropdownFooter>
    <a [routerLink]="['analytics', 'notifications']">
      <sui-button variant="primary">
        {{ "dropdown-notifications.button.view-all" | translate }}
      </sui-button>
    </a>
  </div>
</app-dropdown>
